// Estilo base compartilhado pela família de pills status/atendido-por/departamento.
export const pillBaseSx = {
  height: 'auto',
  borderRadius: 1,
  px: 1,
  py: 0.25,
};

export const pillIconSx = {
  fontSize: 'inherit',
};

// Limite de largura para pills com texto de tamanho variável (ex.: nome de
// colaborador), truncando com reticências em vez de quebrar o layout.
export const pillTruncatedSx = {
  maxWidth: 160,
  '& .MuiChip-label': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};
